import type { LDFlagChangeset, LDFlagSet } from 'launchdarkly-js-client-sdk';

/**
 * Gets the flags to pass to the provider from the changeset.
 *
 * @param changes - the `LDFlagChangeset` from the ldClient onchange handler.
 * @param targetFlags - if targetFlags are specified, changes to other flags are ignored and not returned in the
 * flattened `LDFlagSet`
 * @returns an `LDFlagSet` with the current flag values from the LDFlagChangeset filtered by `targetFlags`. The returned
 * object may be empty `{}` if none of the targetFlags were changed.
 */
export const getFlattenedFlagsFromChangeset = (
  changes: LDFlagChangeset,
  targetFlags?: LDFlagSet | undefined
): LDFlagSet => {
  const flattened: LDFlagSet = {};
  for (const key in changes) {
    const flagKey = key;
    if (!targetFlags || targetFlags[flagKey] !== undefined) {
      flattened[flagKey] = changes[key].current;
    }
  }

  return flattened;
};
